// frontend/src/utils/leadTime.js
//
// Lead time — the time between ordering an item and its delivery, in days.
// One value cascades Store → Supplier → Supplier catalog item by reference
// (backend/api/services/planning_defaults.py): NULL on a supplier or a
// catalog item means "inherit the level above", and the store's value is the
// NOT NULL root. Bounds mirror `core.models.LEAD_TIME_DAYS_MIN/MAX`, which
// are the authority; every screen that offers the field imports from here.
//
// 0 IS a lead time: same-day supply, read as stored with no floor
// (`resolve_need_by_lead_times`). Only a blank inherits.

export const LEAD_TIME_DAYS_MIN = 0;
export const LEAD_TIME_DAYS_MAX = 365;

/**
 * Whether a field's string is a lead time the backend will accept: a whole
 * number inside the bounds. Same predicate as
 * `core.models.lead_time_days_is_valid`, over the string a form control
 * holds rather than a parsed JSON value.
 */
export function isValidLeadTimeDays(text) {
  if (!/^\d+$/.test(text)) return false;
  const days = Number(text);
  return days >= LEAD_TIME_DAYS_MIN && days <= LEAD_TIME_DAYS_MAX;
}
